import axios from "axios";


const BASE_URL = process.env.REACT_APP_BACKEND_URL;


export const sendQuery = (query, chat_id, user_email) =>
    axios
        .post(BASE_URL + "/", {"query": query, "chat_id": chat_id, "user_email": user_email})
        .then((response) => response.data)
        .catch((error) => error)


export const getChatHistory = (chat_id) =>
    axios
        .get(`${BASE_URL}/messages/by-chat/${chat_id}`)
        .then((response) => response)
        .catch((error) => console.log(error))

export const getUserChats = () =>
    axios
        .get(BASE_URL + "/chats/prueba@gmail.com")
        .then((response) => response)
        .catch((error) => error)

export const getUserChatById = (chat_id) =>
    axios
        .get(`${BASE_URL}/chats/${chat_id}`)
        .then((response) => response)
        .catch((error) => error)